import { Component } from '@angular/core';

import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';

@Component({
    selector: 'ms-greyhounds-error-breadcrumb',
    templateUrl: 'greyhounds-error-breadcrumb.html',
    standalone: false,
})
export class GreyhoundsErrorBreadCrumbComponent {
    constructor(private redirectHelper: RedirectHelperService) {}

    goBack() {
        this.redirectHelper.goBack();
    }
}
